/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Billing ownership selected for one WhatsApp onboarding attempt.
 */
export enum WhatsAppBillingMode {
    CUSTOMER_MANAGED = 'customer_managed',
    COMOS_MANAGED = 'comos_managed',
}
